module.exports = __webpack_public_path__ + "static/media/NUS_Logo.d6aae921.png";